// @flow
import * as React from 'react';
import { type ResolvedClientId } from './useUrlResolvedClientId';

export type ResolvedClientIdContextValue = {
    ...ResolvedClientId
};

const ResolvedClientIdContext: React.Context<ResolvedClientIdContextValue | null> = React.createContext(
    null
);

export default ResolvedClientIdContext;
